export enum HeaderType {
  'STAFF' = 'staff',
  'VENDOR' = 'vendor',
  'PURCHASER' = 'purchaser',
  'EATER' = 'eater',
  'ON_DEMAND' = 'on-demand',
  'DEFAULT' = 'default',
}
